import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  return {
    riskFactors: {
      overflow: "visible",
      paddingLeft: 4,
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        paddingLeft: 8
      }
    },
    riskFactorsItem: {
      display: "flex",
      alignItems: "center",
      padding: "0 8px",
      marginLeft: 6,
      height: 21,
      border: `1px solid ${theme.palette.warning.main}`,
      color: theme.palette.warning.dark,
      whiteSpace: "nowrap",
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        height: 24,
        padding: "0 11px"
      }
    },
    risksFactorsNumber: {
      textDecoration: "underline",
      cursor: "pointer",
      color: theme.palette.warning.dark,
      width: 30,
      height: 28,
      minWidth: 30,
      padding: 0,
      borderRadius: "50%",
      "&:hover": {
        textDecoration: "underline",
        cursor: "pointer"
      }
    },
    noRiskFactors: {
      paddingLeft: 6
    }
  };
});
